import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class EnvironmentTemplateService {
    async getEnvironmentTemplates(environmentName?: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/EnvironmentTemplate/`;
        if (environmentName) {
            url += `?environmentName=${encodeURIComponent(environmentName)}`;
        }
        let response = await getAuthenticatedFetch()(url);
        return await response.json();
    }
}

export default new EnvironmentTemplateService();
